'use client'; // This component handles interactivity

import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/autoplay';

// Define the type for the items it will receive
interface PromoItem {
  icon: React.ReactNode;
  title: string;
  subtitle: string;
  link?: string;
}

interface PromoBannerSliderProps {
  items: PromoItem[];
}

export const PromoBannerSlider: React.FC<PromoBannerSliderProps> = ({
  items,
}) => {
  return (
    <Swiper
      modules={[Autoplay]}
      spaceBetween={30}
      slidesPerView={3} // Start with the desktop view
      autoplay={{ delay: 3000, disableOnInteraction: false }}
      loop={true}
      className="promo-banner-swiper"
      breakpoints={{
        0: { slidesPerView: 1 },
        768: { slidesPerView: 2 },
        1200: { slidesPerView: 3 },
      }}
    >
      {items.map((item, index) => (
        <SwiperSlide key={index}>
          <div className="promo-banner__item d-flex justify-content-center align-items-center">
            <div className="promo-banner__icon me-3">{item.icon}</div>
            {item?.link ? (
              <a target="_blank" href={`${item?.link}`}>
                <div className="promo-banner__content">
                  <h6 className="promo-banner__title fw-medium mb-1">
                    {item.title}
                  </h6>
                  <p className="promo-banner__subtitle m-0 fs-small">
                    {item.subtitle}
                  </p>
                </div>
              </a>
            ) : (
              <div className="promo-banner__content">
                <h6 className="promo-banner__title fw-medium mb-1">
                  {item.title}
                </h6>
                <p className="promo-banner__subtitle m-0 fs-small">
                  {item.subtitle}
                </p>
              </div>
            )}
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};
